export const CHECKOUT_E_COMMERCE = {
  SELF: 'checkout',
  CART: 'checkout_cart',
  ADDRESSES: 'checkout_addresses',
  INSURANCE: 'checkout_insurance',
  CHECKOUT: 'checkout_checkout',
  PAYMENT: 'checkout_payment',
  PAYMENT_RESULT: 'checkout_payment_result',
  SERVICES: {
    ROOT: 'checkout_services',
    BOUYGUES: {
      ROOT: 'checkout_services_bouygues_telecom',
      SIGN_UP: 'checkout_services_bouygues_telecom_sign_up',
      AUTH: 'checkout_services_bouygues_telecom_auth',
      PHONELINE_SETUP: 'checkout_services_bouygues_telecom_phoneline_setup',
      NOT_ELIGIBLE: 'checkout_services_bouygues_telecom_not_eligible',
    },
    FREENET: {
      ROOT: 'checkout_services_freenet',
      PHONELINE_SETUP: 'checkout_services_freenet_phoneline_setup',
    },
  },
  WEBVIEW: {
    SERVICES: {
      BOUYGUES: {
        ROOT: 'checkout_webview_services_bouygues_telecom',
        SIGN_UP: 'checkout_webview_services_bouygues_telecom_sign_up',
        AUTH: 'checkout_webview_services_bouygues_telecom_auth',
        PHONELINE_SETUP:
          'checkout_webview_services_bouygues_telecom_phoneline_setup',
        NOT_ELIGIBLE: 'checkout_webview_services_bouygues_telecom_not_eligible',
      },
    },
  },
}
